// MARK://dhk8/admin-shell/components/StatusPill
// Rounded status pill (border-radius full) — fondo = tint del tono (--pos-*-bg),
// texto/realce = color del tono. El label SIEMPRE es visible (accesible: el estado
// no se comunica solo con color). NADA de border-left/edge-strip: el estado es fill
// tint + dot + color de texto, según la regla de marca.
//
// `lifecycleTone(active)` → 'ok' activo / 'danger' inactivo, para que "Inactivo"
// salga pill rojo (decisión Gustavo).

export type StatusTone = 'ok' | 'warn' | 'danger' | 'info' | 'neutral'

export interface StatusPillProps {
  tone: StatusTone
  label: string
}

/** Tono de ciclo de vida: activo = ok (verde), inactivo = danger (rojo). */
export function lifecycleTone(active: boolean): StatusTone {
  return active ? 'ok' : 'danger'
}

// Cada tono mapea a su variable de color y su tint de fondo. 'neutral' usa los
// neutrales del sistema (elevated + fg-secondary) en vez de un color de estado.
const TONE_VARS: Record<StatusTone, { fg: string; bg: string }> = {
  ok: { fg: 'var(--pos-success)', bg: 'var(--pos-success-bg)' },
  warn: { fg: 'var(--pos-warning)', bg: 'var(--pos-warning-bg)' },
  danger: { fg: 'var(--pos-danger)', bg: 'var(--pos-danger-bg)' },
  info: { fg: 'var(--pos-info)', bg: 'var(--pos-info-bg)' },
  neutral: { fg: 'var(--pos-fg-secondary)', bg: 'var(--pos-elevated)' },
}

export default function StatusPill({ tone, label }: StatusPillProps) {
  const { fg, bg } = TONE_VARS[tone]
  return (
    <span
      className="nui-status-pill"
      style={{ color: fg, background: bg }}
      data-tone={tone}
    >
      <span className="nui-status-pill__dot" style={{ background: fg }} aria-hidden />
      <span className="nui-status-pill__label">{label}</span>
      <style>{`
        .nui-status-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 2px 10px;
          border-radius: var(--pos-radius-full, 9999px);
          font-size: var(--pos-text-xxs, 11px);
          font-weight: var(--pos-weight-semibold, 600);
          line-height: var(--pos-leading-tight, 1.15);
          white-space: nowrap;
          max-width: 100%;
        }
        .nui-status-pill__dot {
          width: 6px;
          height: 6px;
          border-radius: var(--pos-radius-dot, 9999px);
          flex-shrink: 0;
        }
        .nui-status-pill__label {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </span>
  )
}
